import { render, staticRenderFns } from "./NetworksOficinaDetail.vue?vue&type=template&id=7ab64a2c&"
import script from "./NetworksOficinaDetail.vue?vue&type=script&lang=js&"
export * from "./NetworksOficinaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports